import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Checkbox as MUICheckbox } from '@material-ui/core';
import { CheckboxProps } from '@material-ui/core/Checkbox';
import { Checked, UnChecked } from '@marqvision/mds-v2/components/atoms/Checkbox/Icons';
import theme from './Theme';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
  },
  checkbox: {
    '&.primary > .MuiIconButton-label > input + .MuiSvgIcon-root': {
      color: theme.palette.bluegray['300'],
    },
    '&.primary.Mui-checked > .MuiIconButton-label > .MuiSvgIcon-root': {
      color: theme.palette.blue['700'],
    },
    '&.primary.Mui-checked.Mui-disabled > .MuiIconButton-label > .MuiSvgIcon-root': {
      color: theme.palette.blue['200'],
    },
    '&.primary.Mui-disabled > .MuiIconButton-label > .MuiSvgIcon-root': {
      color: theme.palette.bluegray['150'],
    },
    '&.primary.MuiCheckbox-indeterminate > .MuiIconButton-label > .MuiSvgIcon-root ': {
      color: theme.palette.blue['700'],
    },
    '&.basic > .MuiIconButton-label > input + .MuiSvgIcon-root': {
      color: theme.palette.white,
    },
    '&.basic.Mui-checked > .MuiIconButton-label > .MuiSvgIcon-root': {
      color: theme.palette.white,
    },
    '&.basic.checked.Mui-disabled > .MuiIconButton-label > .MuiSvgIcon-root': {
      color: theme.palette.white,
    },
    '&.basic.Mui-disabled > .MuiIconButton-label > .MuiSvgIcon-root': {
      color: theme.palette.white,
      opacity: '0.5',
    },
  },
  disabledArea: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '14px',
    height: '14px',
    '&.primary': {
      backgroundColor: theme.palette.bluegray['50'],
    },
    '&.basic': {
      opacity: '0.3',
      backgroundColor: theme.palette.white,
    },
  },
}));

interface ICheckboxProps {
  isPrimary?: boolean;
  className?: string;
}

type IProps = CheckboxProps & ICheckboxProps;
/**
 * @deprecated
 * mds-v2 로 변경
 */
export const MDSCheckbox = (props: IProps): JSX.Element => {
  const classes = useStyles();
  const { isPrimary, size: _size = 'medium', ...restProps } = props;

  const size = _size === 'small' ? 20 : 24;

  return (
    <div className={classes.root}>
      <MUICheckbox
        {...restProps}
        className={clsx(classes.checkbox, { primary: isPrimary, basic: !isPrimary }, props.className)}
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox={`0 0 ${size} ${size}`}
            className="MuiSvgIcon-root"
            style={{ fill: 'transparent' }}
          >
            {UnChecked[_size]}
          </svg>
        }
        checkedIcon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox={`0 0 ${size} ${size}`}
            className="MuiSvgIcon-root"
          >
            {Checked[_size]}
          </svg>
        }
      />
      {props.disabled && !props.checked && !props.indeterminate && (
        <div className={clsx(classes.disabledArea, { primary: isPrimary, basic: !isPrimary })} />
      )}
    </div>
  );
};

export default MDSCheckbox;
